import { render, staticRenderFns } from "./IndividualSummary.vue?vue&type=template&id=7155e465&scoped=true"
import script from "./IndividualSummary.vue?vue&type=script&lang=ts"
export * from "./IndividualSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155e465",
  null
  
)

export default component.exports